<script lang="ts">
    import { Dot, Label } from "attractions";
    import Select from "svelte-select";
    import { toasts } from "svelte-toasts";
    import AppConfig from "../../../app.config";

    const filesExtensions = {
        internal: '.json'
    }
    const items = [
        { label: window.location.host, value: 'internal' }
    ];

    let value;

    function notifyAboutDownloadingTheFile() {
        toasts.success(`Sukces`, `Pobieranie pliku zostanie rozpoczęte w ciągu kilku sekund.`)
    }
</script>

<section class="exportProducts">
    <Label style="margin-bottom: .35rem">Wybór platformy docelowej</Label>
    <Select bind:value {items} placeholder="Wybierz..." isSearchable={false} />
    {#if value && value.value}
        <Label style="margin-top: .35rem">Format docelowy</Label>
        <small class="fileExtension">{filesExtensions[value.value]}</small>
        <Label style="margin-top: .35rem">Nazwa pliku</Label>
        <small class="fileExtension">products(<i>liczba produktów</i>)_export(<i>dzisiejsza data</i>).json</small>
        <Label style="margin-top: .35rem">Pobieranie</Label>
        {#if value.value == 'internal'}
            <a on:click={notifyAboutDownloadingTheFile} href="{AppConfig.REST.URL}/export/products" class="download"><Dot success /> <span class="label">Pobierz plik</span></a>
        {/if}
    {/if}
</section>

<style lang="scss">
    .exportProducts {
        min-width: 300px;

        .download {
            display: flex;
            align-items: center;
            margin-top: .35rem;
            cursor: pointer;

            .label {
                margin-left: .2rem;
                font-size: .9rem;
            }
        }

        .fileExtension {
            display: block;
            color: gray;
            margin-top: .35rem;
            font-size: .85rem;
        }
    }
</style>